<div class="editprofile" style="padding: 10px;">
    <h2 mat-dialog-title>Edit {{ data.label }}</h2>

    <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'" style=" MARGIN: 0PX; padding: 0px;">
        <mat-form-field *ngIf="data.type != 'date'" appearance="outline" class="w-full">
            <mat-label>{{ data.label }}</mat-label>
            <ng-container *ngIf="data.label?.toLowerCase() === 'company'; else normalInput">
                <input [attr.guide]="'field-edit-dialog-inp-company' + '__' + sanitizedUrl" matInput
                    [(ngModel)]="data.value" (input)="getCompanyData(data.value)" [matAutocomplete]="auto"
                    [placeholder]="data.label" [required]="data.isRequired == 1" #companyInput="ngModel"
                    name="company" />

                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option (onSelectionChange)="onCompanySelected($event,opt, data.element)"
                        *ngFor="let opt of companyList" [value]="opt.name">
                        {{ opt.name }}
                    </mat-option>
                    <mat-option (onSelectionChange)="addNewCompany(data.element, data.value)"
                        *ngIf="companyList?.length === 0 && data.value">
                        <mat-icon color="primary" class="mr-2">add_circle</mat-icon>
                        Add "{{ data.value }}" as a new company
                    </mat-option>
                </mat-autocomplete>
            </ng-container>
            <ng-template #normalInput>
                <input [attr.guide]="'field-edit-dialog-inp-text' + '__' + sanitizedUrl" *ngIf="data.type === 'text'"
                    matInput [(ngModel)]="data.value" [type]="data.type" [required]="data.isRequired == 1"
                    #textInput="ngModel" name="text" />

                <input numbersOnly [attr.guide]="'field-edit-dialog-inp-text' + '__' + sanitizedUrl"
                    *ngIf="data.type === 'number'" matInput [(ngModel)]="data.value" [required]="data.isRequired == 1"
                    #textInput="ngModel" name="text" />
            </ng-template>


            <mat-select *ngIf="data.type === 'select' || data.type === 'multiselect'" [(ngModel)]="data.value"
                [multiple]="data.type === 'multiselect'" [required]="data.isRequired == 1" #selectInput="ngModel"
                #matSelect (selectionChange)="data.type === 'multiselect' ? matSelect.close() : null" name="select">
                <ng-container *ngIf="data.label == 'Sales owner' || data.label == 'Owner'">
                    <mat-option (onSelectionChange)="onOwnerSelected($event,opt, data.element)"
                        *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.email">
                        {{opt.email}}
                    </mat-option>
                </ng-container>
                <ng-container *ngIf="data.label == 'Lifecycle stage'">
                    <mat-option *ngFor="let opt of lifeCyleStageList; let i=index;" [value]="opt.name">
                        {{opt.name}}
                    </mat-option>
                </ng-container>
                <ng-container *ngIf="data.label?.toLowerCase() == 'country'">
                    <mat-option>
                        <input [attr.guide]="'field-edit-dialog-inp-1' + '__' + sanitizedUrl" matInput
                            placeholder="Search country" [formControl]="countryFilterControl"
                            (click)="$event.stopPropagation()" />
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredcountryTypeList" [value]="opt.countryName">
                        {{ opt.countryName }}
                    </mat-option>

                </ng-container>
                
                <ng-container *ngIf="data.label?.toLowerCase() == 'state'">
                    <mat-option>
                        <input [attr.guide]="'field-edit-dialog-inp-st' + '__' + sanitizedUrl" matInput
                            placeholder="Search state" [formControl]="stateFilterControl"
                            (click)="$event.stopPropagation()" />
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredLocationStates" [value]="opt.name">
                        {{ opt.name }}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label?.toLowerCase() == 'city'">
                    <mat-option>
                        <input [attr.guide]="'field-edit-dialog-inp-ci' + '__' + sanitizedUrl" matInput
                            placeholder="Search city" [formControl]="cityFilterControl"
                            (click)="$event.stopPropagation()" />
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredLocationCities" [value]="opt.name">
                        {{ opt.name }}
                    </mat-option>
                </ng-container>


                <ng-container *ngIf="data.label == 'Status Name' || data.label == 'Lead Status'">
                    <mat-option class="white-text"
                        (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId,opt.statusId)"
                        *ngFor="let opt of filteredleadStatusTypeList; let i=index;" [value]="opt.statusId">
                        {{opt.statusName}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label =='Industry Type'">
                    <mat-option *ngFor="let opt of filteredindustryTypeList; let i=index;"
                        [value]="opt.statusId">{{opt.statusName}}</mat-option>
                </ng-container>

                <ng-container *ngIf="data.label =='Business Type'">
                    <mat-option *ngFor="let opt of filteredBusinessTypeList; let i=index;"
                        [value]="opt.statusId">{{opt.statusName}}</mat-option>
                </ng-container>

                <ng-container *ngIf="data.label == 'Lead Source' ">
                    <mat-option *ngFor="let opt of filteredLeadSourceTypeList; let i=index;" [value]="opt.sourceId">
                        {{opt.sourceName}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label == 'Tag Name' || data.label == 'Tag'">
                    <mat-option *ngFor="let opt of filteredTagsList; let i=index;" [value]="opt.statusId">
                        {{opt.statusName}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label == 'Status' || data.label == 'Call Status'">
                    <mat-option *ngFor="let opt of filteredUserCallStatusTypeList" [value]="opt.Status">
                        {{opt.Status}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label == 'Type of Service'">
                    <mat-option *ngFor="let opt of filteredPayemntTypeList" [value]="opt.name">
                        {{opt.name}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label == 'Supplier'">
                    <mat-option *ngFor="let opt of filteredsupplierTypeList" [value]="opt.name">
                        {{opt.name}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label == 'Location' || data.label == 'Warehouse'">
                    <mat-option *ngFor="let opt of filteredWarehouseTypeList" [value]="opt.name">
                        {{opt.name}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label == 'Deal Stage' || data.label == 'Stage' || data.label == 'Stage Name'">
                    <mat-option *ngFor="let opt of filteredlDealStatusTypeList" [value]="opt.statusName">
                        {{opt.statusName}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label == 'Tracker' || data.label == 'Tracker Name'">
                    <mat-option *ngFor="let opt of filteredTrackerTypeList" [value]="opt.name">
                        {{opt.name}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label == 'Task Status'">
                    <mat-option *ngFor="let opt of filteredTaskStatusTypeList" [value]="opt.statusName">
                        {{opt.statusName}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="data.label == 'Priority'">
                    <mat-option *ngFor="let opt of filteredPriorityTypeList" [value]="opt.name">
                        {{opt.name}}
                    </mat-option>
                </ng-container>

                <ng-container
                    *ngIf="data.label == 'Time Zone' || data.element?.field_key == 'time_zone' || data.label == 'TimeZone'">
                    <mat-option class="search-option">
                        <input [attr.guide]="'field-edit-dialog-inp-tz' + '__' + sanitizedUrl" matInput
                            placeholder="Search Time Zone" [formControl]="timeZoneFilterControl"
                            (click)="$event.stopPropagation()" />
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredZones" [value]="opt.value">
                        {{opt.value}}
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="optionValues.length > 0">
                    <mat-option class="search-option">
                        <input [attr.guide]="'field-edit-dialog-inp-2' + '__' + sanitizedUrl" matInput
                            placeholder="Search" [formControl]="optionFilterControl"
                            (click)="$event.stopPropagation()" />
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredOptionValues" [value]="opt.value">
                        {{ opt.viewValue }}
                    </mat-option>
                </ng-container>

            </mat-select>

            <mat-select *ngIf="data.type === 'boolean'" [(ngModel)]="data.value" [required]="data.isRequired == 1">
                <mat-option *ngFor="let status of booleanField" [value]="status.value">
                    {{status.viewValue}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="data?.isRequired == 1">Please fill out this field.</mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="data.type === 'date'" appearance="outline" class="w-full">
            <mat-label>{{ data.label }}</mat-label>
            <input [attr.guide]="'field-edit-dialog-inp-3' + '__' + sanitizedUrl" matInput [matDatepicker]="picker"
                [(ngModel)]="data.value" [required]="data.isRequired == 1" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="data.isRequired == 1">Please fill out this field.</mat-error>
        </mat-form-field>

        <div *ngIf="formInit" style="width: 100%; display: block; margin-top: 15px;">
            <simple-dynamic-form #dynamicForm [layout]="2" [formValue]="patchValues"
                (submitLeadDetail)="saveNew($event)" [status]="firstFormGroup.value.LeadStatus" [formType]="'outline'"
                [type]="2" (submit)="onFormSubmitted($event)" [fields]="regConfig">
            </simple-dynamic-form>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button [attr.guide]="'field-edit-dialog-btn-4' + '__' + sanitizedUrl" mat-button
            (click)="close()">Cancel</button>
        <button [attr.guide]="'field-edit-dialog-btn-5' + '__' + sanitizedUrl" mat-flat-button color="primary"
            (click)="save()">Save</button>
    </mat-dialog-actions>
</div>